module.exports = __webpack_public_path__ + "img/img (17).b55e95a4.jpg";